const benefits = [
  {
    icon: "ri-timer-flash-line",
    title: "Oszczędność czasu",
    desc: "Setki przeanalizowanych profili w jednym arkuszu. Koniec z ręcznym researchowaniem, które zajmowało godziny.",
  },
  {
    icon: "ri-search-eye-line",
    title: "Lepszy research",
    desc: "Dokładne dane analityczne pozwalają podejmować trafniejsze decyzje biznesowe przy wyborze twórców.",
  },
  {
    icon: "ri-user-search-line",
    title: "Skuteczniejszy scouting",
    desc: "Szybkie wyszukiwanie i filtrowanie twórców według niszy, zasięgów i wskaźników zaangażowania.",
  },
  {
    icon: "ri-line-chart-line",
    title: "Lepsze decyzje biznesowe",
    desc: "Dane w czasie rzeczywistym pomagają optymalizować kampanie i zwiększać ROI każdej współpracy.",
  },
];

export default function BenefitsSection() {
  return (
    <section className="relative w-full bg-background-100 py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Dlaczego USFans Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Narzędzie stworzone z myślą o agencjach i twórcach, którzy chcą pracować szybciej i skuteczniej.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="group p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 mb-4 group-hover:bg-primary-200 transition-colors duration-200">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}